/**
 * loading加载动画封装
 * @author HeYq
 * @date 2021-1-27
 * @version 1.0
 */
import { Loading } from 'element-ui'

let needLoadingRequestCount = 0 // 记录创建Loading实例的个数，只有在个数变为0才回去关闭或开启另一个实例
let loading // loading实例变量

/**
 * 实例化一个新的loading实例
 */
function startLoading () {
  loading = Loading.service({
    lock: true,
    customClass: 'seller-loading',
    background: 'rgba(0, 0, 0, 0.6)'
  })
}

/**
 * 终止loading实例
 * 指定target后，每次返回的都是单独的实例，所以要在调用新的loading之前检测是否有实例存在，如果有择用close方法
 */
function endLoading () {
  loading && loading.close()
}

/**
 * 显示loading，在显示之前，先判断是否已有实例化的loading
 * 已有实例时，则增加已有实例个数
 * 没有实例，则实例化loading
 */
export function showFullScreenLoading () {
  if (needLoadingRequestCount === 0) {
    startLoading()
  }
  needLoadingRequestCount++
}

/**
 * 关闭loading，判断实例个数是否为零
 * 为零则关闭，反之减少实例个数
 */
export function tryHideFullScreenLoading () {
  if (needLoadingRequestCount <= 0) return
  needLoadingRequestCount--
  if (needLoadingRequestCount === 0) {
    endLoading()
  }
}



// WEBPACK FOOTER //
// ./src/utils/loading.js